import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { ReactNode } from 'react';
import { useState } from 'react';

export const FloatInput = ({
  label,
  placeholder,
  helperText,
  initialValue,
  onChanged,
  units,
}: {
  label: string;
  placeholder: string;
  helperText?: string;
  initialValue: number;
  onChanged: (value?: number) => void;
  units: ReactNode;
}) => {
  const [value, setValue] = useState(initialValue.toString());
  const onChange = (value: string) => setValue(value);
  const onBlur = (value: string) => {
    const newValue = parseFloat(value);
    if (isNaN(newValue)) {
      setValue('');
      onChanged(undefined);
    } else {
      setValue(newValue.toString());
      onChanged(newValue);
    }
  };

  return (
    <Stack width={250}>
      <TextInput
        label={label}
        placeholder={placeholder}
        slotProps={{
          input: {
            endAdornment: units,
          },
        }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onBlur(e.target.value)}
      />
      {helperText && (
        <Stack paddingX={theme.spacing['4']} paddingY={theme.spacing['1']}>
          <Typography style={{ ...theme.typography.body.small }}>
            {helperText}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
